import { createFileRoute } from '@tanstack/react-router';
import { SignedOutPage } from '@hlt/web-kit/shell';

/** `/auth/signed-out?next=`: hop of a sign-out that started in a tool; clears this app's browser state. */
export const Route = createFileRoute('/auth/signed-out')({
    validateSearch: (search: Record<string, unknown>): { next?: string } =>
        typeof search.next === 'string' ? { next: search.next } : {},
    component: function SignedOutRoute() {
        const { next } = Route.useSearch();
        return <SignedOutPage next={next} />;
    },
});
